import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    data: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchQuantity = createAsyncThunk(
    'quantity/fetchQuantity',
    async ({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                `${APP_URL}/statistics/count-table?${params}`,
                'GET',
                null,
                customHeaders
            );

            return response.data
        } catch (error) {
            console.log(error);
            return rejectWithValue(error.status);
        }
    }
);

const quantitySlice = createSlice({
    name: 'quantity',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchQuantity.pending, (state) => {
                state.loadingStatus = 'loading';
            })
            .addCase(fetchQuantity.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchQuantity.rejected, (state) => {
                state.loadingStatus = 'error';
            })
    }
});

export default quantitySlice.reducer;